import { render, staticRenderFns } from "./ResetPasswordSuccessPage.vue?vue&type=template&id=017580b7&"
import script from "./ResetPasswordSuccessPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports